import { FC } from 'react';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { useAppSelector } from 'redux/hooks';
import { NormalModalConditions } from './NormalModalConditions';
import { Props } from '..';
import { PreBtn2 } from './DrillDown/PreBtn2';
import { PreBtn1 } from './DrillDown/PreBtn1';

export const ModalConditions: FC<Props> = ({
  conditions,
  modalAction,
  getJobCountAtModalDisplay,
  updateJobCount,
  onChangeIsShowOverlay,
}) => {
  const { preBtn } = useAppSelector(appQueryParamsSelector);

  if (preBtn === '1') {
    return (
      <PreBtn1
        conditions={conditions}
        modalAction={modalAction}
        getJobCountAtModalDisplay={getJobCountAtModalDisplay}
        updateJobCount={updateJobCount}
        onChangeIsShowOverlay={onChangeIsShowOverlay}
      />
    );
  }

  if (preBtn === '2') {
    return (
      <PreBtn2
        conditions={conditions}
        modalAction={modalAction}
        getJobCountAtModalDisplay={getJobCountAtModalDisplay}
        updateJobCount={updateJobCount}
        onChangeIsShowOverlay={onChangeIsShowOverlay}
      />
    );
  }

  return (
    <NormalModalConditions
      conditions={conditions}
      modalAction={modalAction}
      getJobCountAtModalDisplay={getJobCountAtModalDisplay}
      updateJobCount={updateJobCount}
      onChangeIsShowOverlay={onChangeIsShowOverlay}
    />
  );
};
